import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getFirmaPersonal = async (IdPersonal) => {
        const result = await PrivateInterceptor(`payrolls/Firmas/${IdPersonal}`, 'GET');
        if(result){
            var binary = '';
            var bytes = [].slice.call(new Uint8Array(result.data));
            bytes.forEach((b) => binary += String.fromCharCode(b));
            const base64String = window.btoa(binary);
            return base64String;
        }else{
            return null;
        }
}